import { render, staticRenderFns } from "./DialogOperations.vue?vue&type=template&id=4887b646&scoped=true"
import script from "./DialogOperations.vue?vue&type=script&lang=js"
export * from "./DialogOperations.vue?vue&type=script&lang=js"
import style0 from "./DialogOperations.vue?vue&type=style&index=0&id=4887b646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887b646",
  null
  
)

export default component.exports